// Dialog titles
export const DIALOG_TITLE_DATE_VISITE = "Saisie de la date réelle de visite qualité";
export const DIALOG_DATE_VISITE_INPUT_TEXT = "Veuillez renseigner la date réelle de visite qualité.";
export const DIALOG_DATE_VISITE_DESCRIPTION = "* Cette date est obligatoire et alimentera l'application Planning.";
export const DIALOG_DATE_VISITE_BTN = "Enregistrer et envoyer le Rapport";
